module.exports = __webpack_public_path__ + "files/8a86a0afd5a0b172bdc93be1e3d53866.woff2";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/katex/dist/fonts/KaTeX_Size2-Regular.woff2
// module id = 1443
// module chunks = 59